var require_runtime = require('../../_virtual/_rolldown/runtime.cjs');
//#region src/types/plugins/ModuleFederationPlugin.ts
var ModuleFederationPlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});
//#endregion
Object.defineProperty(exports, 'ModuleFederationPlugin_exports', {
    enumerable: true,
    get: function get() {
        return ModuleFederationPlugin_exports;
    }
}); //# sourceMappingURL=ModuleFederationPlugin.cjs.map
